import gql from 'graphql-tag'

export const GetProductsQuery = gql`
  query getProducts(
    $gender: String
    $category: String
    $sport: String
    $season: String
    $limit: Int
    $order: String
    $offset: Int
  ) {
    products(
      gender: $gender
      category: $category
      sport: $sport
      season: $season
      limit: $limit
      order: $order
      offset: $offset
    ) {
      fullCount
      products {
        id
        code
        yotpoId: yotpo_id
        name
        type: name
        active
        hasSizeRecEnabled: has_size_rec_enabled
        description: short_description
        shortDescription: short_description
        collections
        isTopProduct
        sizeTag: size_tag
        youthCombined: youth_combined
        hideFitStyles: hide_fit_styles
        weight
        twoPieces: two_pieces
        genders {
          id
          name: gender
        }
        fitStyles {
          id
          info
          name: description
        }
        sizeRange: size_range {
          id
          name
          isYouth: is_youth
        }
        priceRange {
          quantity
          price
          abbreviation
          shortName: short_name
        }
        images: pictures {
          front: front_image
          back: back_image
          left: left_image
          right: right_image
        }
      }
    }
  }
`



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--5!./src/components/DesignsCatalogueThumbnailList/data.ts